(() => {
  if (customElements.get('hero-banner-slider')) return;
  customElements.define('hero-banner-slider', class extends HTMLElement {
    connectedCallback() {
      this.slides = [...this.querySelectorAll('.banner-hero__slide')];
      this.dots = [...this.querySelectorAll('.banner-hero__dot')];
      this.index = 0;
      this.busy = null;
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.speed = +this.dataset.speed || 700;
      this.interval = +this.dataset.interval || 6000;
      this.autoplay = this.dataset.autoplay === 'true' && !this.reduced;
      this.hovering = false;

      this.addEventListener('click', (e) => {
        if (this.swiped) { e.preventDefault(); this.swiped = false; return; }
        if (e.target.closest('.prev')) return this.go(this.index - 1, 'prev');
        if (e.target.closest('.next')) return this.go(this.index + 1, 'next');
        const dot = e.target.closest('.banner-hero__dot');
        if (dot) {
          const to = +dot.dataset.go;
          this.go(to, to < this.index ? 'prev' : 'next');
        }
      });
      this.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft') this.go(this.index - 1, 'prev');
        if (e.key === 'ArrowRight') this.go(this.index + 1, 'next');
      });
      this.addEventListener('mouseenter', () => { this.hovering = true; this.stop(); });
      this.addEventListener('mouseleave', () => { this.hovering = false; this.play(); });

      let startX = 0, startY = 0, tracking = false;
      this.addEventListener('pointerdown', (e) => {
        if (e.pointerType === 'mouse') return;
        startX = e.clientX; startY = e.clientY; tracking = true; this.stop();
      });
      this.addEventListener('pointerup', (e) => {
        if (!tracking) return;
        tracking = false;
        const dx = e.clientX - startX;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(e.clientY - startY)) {
          this.swiped = true;
          setTimeout(() => { this.swiped = false; }, 300);
          this.go(this.index + (dx < 0 ? 1 : -1), dx < 0 ? 'next' : 'prev');
        }
        this.play();
      });
      this.addEventListener('pointercancel', () => { tracking = false; this.play(); });

      document.addEventListener('visibilitychange', () => (document.hidden ? this.stop() : this.play()));
      this.addEventListener('shopify:block:select', (e) => {
        const i = this.slides.findIndex((s) => s.contains(e.target));
        if (i > -1) this.go(i, 'next', true);
        this.stop();
      });
      this.addEventListener('shopify:block:deselect', () => this.play());

      this.syncVideos();
      this.fit();
      this.ro = new ResizeObserver((entries) => {
        if (entries.some((e) => e.target === this.slides[this.index])) this.fit();
      });
      this.slides.forEach((s) => this.ro.observe(s));
      this.querySelectorAll('video').forEach((v) => v.addEventListener('loadedmetadata', () => this.fit()));
      this.play();
    }

    disconnectedCallback() { this.stop(); if (this.ro) this.ro.disconnect(); }

    fit() {
      const h = this.slides[this.index].offsetHeight;
      if (h) this.style.height = h + 'px';
    }

    stop() { clearTimeout(this.timer); }

    play() {
      this.stop();
      if (this.autoplay && !this.hovering && this.slides.length > 1) {
        this.timer = setTimeout(() => this.go(this.index + 1, 'next'), this.interval);
      }
    }

    finish() {
      if (!this.busy) return;
      clearTimeout(this.busy.t);
      this.busy.out.classList.remove('is-leaving');
      this.busy = null;
    }

    go(to, dir, instant) {
      const count = this.slides.length;
      if (count < 2) return;
      to = (to + count) % count;
      if (to === this.index) return this.play();
      this.finish();

      const out = this.slides[this.index];
      const next = this.slides[to];
      this.dataset.dir = dir;
      next.classList.remove('is-active');
      void next.offsetWidth;
      out.classList.remove('is-active');
      if (!this.reduced && !instant) {
        out.classList.add('is-leaving');
        this.busy = { out, t: setTimeout(() => this.finish(), this.speed + 100) };
      }
      next.classList.add('is-active');
      this.index = to;

      this.slides.forEach((s, i) => s.setAttribute('aria-hidden', i === to ? 'false' : 'true'));
      this.dots.forEach((d, i) => d.setAttribute('aria-current', i === to ? 'true' : 'false'));
      this.syncVideos();
      this.fit();
      this.play();
    }

    syncVideos() {
      this.slides.forEach((s, i) => {
        s.querySelectorAll('video').forEach((v) => {
          if (i !== this.index) v.pause();
          else if (v.muted && v.autoplay) v.play().catch(() => {});
        });
      });
    }
  });
})();
